import PageLabelBar from "../../components/common/PageLabelBar/PageLabelBar";

export default function Certificati() {
    return (
        <div className="content">
            <PageLabelBar title="I tuoi Certificati" />
        </div>
    );
}